import Vue from "vue";
import { IS_LOADING, IS_SAVING } from "../constants.js";
import {
	REDUCER_NAME,
	CONTRACT_DATA,
	CONTRACT_FORM_DATA,
	SET_IS_LOADING_CONTRACT_DATA,
	SET_IS_SAVING_CONTRACT_DATA,
	SET_CONTRACT_DATA,
	SET_CONTRACT_FORM_DATA,
	SET_CONTRACT_RESPONSE_DATA,
	UPDATE_EXPENSES,
} from "./constants.js";

const setIsLoadingContractData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[IS_LOADING]: payload,
	});
};

const setIsSavingContractData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[IS_SAVING]: payload,
	});
};

const setContractData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[CONTRACT_DATA]: payload,
	});
};

const setContractFormData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[CONTRACT_FORM_DATA]: payload,
	});
};

const updateExpenses = function (state, payload) {
	const contractData = state[REDUCER_NAME][CONTRACT_DATA];
	if (contractData) {
		Vue.set(contractData, "expenses", payload);
	}
};

const mutations = {
	[SET_IS_LOADING_CONTRACT_DATA](state, payload) {
		setIsLoadingContractData(state, payload);
	},
	[SET_IS_SAVING_CONTRACT_DATA](state, payload) {
		setIsSavingContractData(state, payload);
	},
	[SET_CONTRACT_DATA](state, payload) {
		setContractData(state, payload);
	},
	[SET_CONTRACT_FORM_DATA](state, payload) {
		setContractFormData(state, payload);
	},
	[SET_CONTRACT_RESPONSE_DATA](state, payload) {
		setContractData(state, payload);
	},
	[UPDATE_EXPENSES](state, payload) {
		updateExpenses(state, payload);
	},
};

export { mutations };
